import { Link } from '@tanstack/react-router';
import { locales, localeHomePath, useHomeStrings, useLocale } from '../../../i18n';

export default function Footer() {
  const year = new Date().getFullYear()
  const t = useHomeStrings().footer
  const currentLocale = useLocale()

  return (
    <footer className="bg-background border-t border-border/60">
      <div className="max-w-5xl mx-auto py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex justify-center space-x-6 md:order-2">
          <a href="https://github.com/stanvanrooy" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
            <span className="sr-only">GitHub</span>
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
            </svg>
          </a>

          <a href="mailto:stanvanrooy6@gmail.com" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
            <span className="sr-only">Email</span>
            <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z" fill="currentColor"/>
            </svg>
          </a>
            
        </div>
        <div className="mt-8 md:mt-0 md:order-1 flex flex-col items-center md:items-start gap-y-4">
          <nav className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2" aria-label="Footer navigation">
            <Link to={localeHomePath(currentLocale)} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.home}
            </Link>
            <Link to="/docs" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.docs}
            </Link>
            <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.blog}
            </Link>
            <Link to="/gltf-compressor" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.gltfCompressor}
            </Link>
            <Link to="/gltf-to-glb" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.gltfToGlb}
            </Link>
            <Link to="/gltf-validator" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
              {t.gltfValidator}
            </Link>
          </nav>
          {locales.length > 1 && (
            <nav className="flex flex-wrap justify-center md:justify-start gap-x-4 gap-y-2" aria-label={t.language}>
              {locales.map((locale) => (
                <Link
                  key={locale.code}
                  to={localeHomePath(locale.code)}
                  hrefLang={locale.hreflang}
                  lang={locale.hreflang}
                  aria-current={locale.code === currentLocale ? 'page' : undefined}
                  className={`text-xs transition-colors duration-200 ${locale.code === currentLocale ? 'text-foreground font-medium' : 'text-muted-foreground hover:text-foreground'}`}
                >
                  {locale.name}
                </Link>
              ))}
            </nav>
          )}
          <p className="text-center text-sm text-muted-foreground/80">
            &copy; {year} Rooy Development. {t.rights}
          </p>
        </div>
      </div>
    </footer>
  )
}

